import { render, staticRenderFns } from "./ManageAdvertisersAndCompanies.vue?vue&type=template&id=49c1b2c4"
import script from "./ManageAdvertisersAndCompanies.vue?vue&type=script&lang=js"
export * from "./ManageAdvertisersAndCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports